import CompaniesListPageReducer from './CompaniesListPageReducer';

export default from './CompaniesListPageContainer';
export const CompaniesListPageReducers = {
  CompaniesListPageReducer,
};
